import { render, staticRenderFns } from "./MedicoHeader.vue?vue&type=template&id=150ea1ac&scoped=true"
import script from "./MedicoHeader.vue?vue&type=script&lang=ts"
export * from "./MedicoHeader.vue?vue&type=script&lang=ts"
import style0 from "./MedicoHeader.vue?vue&type=style&index=0&id=150ea1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ea1ac",
  null
  
)

export default component.exports